var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-list',{attrs:{"buttons":_vm.buttons},on:{"partica-event":_vm.buttonClicked}})}
var staticRenderFns = []

export { render, staticRenderFns }